import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ShopSection() {
  return <section id="shop" className="py-24 bg-rhino-black relative border-t border-rhino-grey" data-id="element-132">
      <div className="container mx-auto px-6 text-center" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rhino-charcoal border border-rhino-grey mb-6" data-id="element-135">
            <ShoppingBag className="w-8 h-8 text-gray-500" data-id="element-136" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-400 tracking-wide mb-4" data-id="element-138">
            APPAREL & MERCHANDISE
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-139">
          <p className="text-xl text-gray-500 mb-8 font-medium" data-id="element-140">
            Shop coming soon. Gear up for the charge.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-141">
          <button disabled className="px-8 py-3 bg-rhino-charcoal text-gray-600 font-heading font-bold text-lg tracking-wider uppercase rounded cursor-not-allowed border border-rhino-grey inline-flex items-center gap-2" data-id="element-142">
            Visit Store
          </button>
        </FadeIn>
      </div>
    </section>;
}